import { render, staticRenderFns } from "./GolfpracticePage.vue?vue&type=template&id=430130ce&scoped=true&"
import script from "./GolfpracticePage.vue?vue&type=script&lang=js&"
export * from "./GolfpracticePage.vue?vue&type=script&lang=js&"
import style0 from "./GolfpracticePage.vue?vue&type=style&index=0&id=430130ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430130ce",
  null
  
)

/* custom blocks */
import block0 from "./GolfpracticePage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports